import ExtensionAPI from 'echarts/lib/core/ExtensionAPI';
import { EChartsExtensionInstallRegisters } from 'echarts/lib/extension';
import { DvLineSeriesModel } from './type';

/**
 * dvShowSymbolStrategy.ts - 智能显示策略扩展
 * 
 * 功能说明：
 * 智能Symbole显示策略扩展，用于根据数据密度动态控制是否显示数据点标记。
 * 
 * 主要特性：
 * 1. 动态调整：根据当前视图内的数据点数量自动决定是否显示符号标记
 * 2. 性能优化：当数据点过多时自动隐藏符号，提高渲染性能
 * 3. 视觉优化：当数据点较少时显示符号，提升数据可读性
 * 4. 灵活配置：通过 dvShowSymbolStrategy 参数设置密度阈值
 * 
 * 工作原理：
 * - 在系列更新前（series:beforeupdate）触发策略检查
 * - 遍历所有折线图系列，获取每个系列的数据点数量
 * - 当数据点数量 ≤ 阈值时显示符号（showSymbol = true）
 * - 当数据点数量 > 阈值时隐藏符号（showSymbol = false）
 * 
 * 使用场景：
 * - 大数据量折线图的性能优化
 * - 自适应数据密度的可视化展示
 * - 需要在数据密度和可读性之间平衡的场景
 */

/**
 * 解析符号密度并动态调整显示策略
 * @param chart ECharts 图表实例的 ExtensionAPI
 */
function parseSymbolDensity(chart: ExtensionAPI) {
  const ecModel = chart.getModel();
  const lineModels = ecModel.getSeriesByType('line');
  
  lineModels.forEach((model: DvLineSeriesModel) => {
    const data = model.getData();
    const densityLevel = model.get('dvShowSymbolStrategy');

    // 如果dvShowSymbolStrategy不为空且大于0
    // 则根据视图内数据个数动态调整showSymbol配置
    // 数据个数大于密度阈值时，不显示symbol，showSymbol为false;
    // 数据个数小于等于密度阈值时，显示symbol，showSymbol为true;
    if (densityLevel) {
      model.option.showSymbol = data.count() <= densityLevel;
    }
  });
}

export function install(registers: EChartsExtensionInstallRegisters) {
  registers.registerUpdateLifecycle('series:beforeupdate', (ecModel, api) => {
    parseSymbolDensity(api);
  });
}
